import { useLayoutEffect, useState, useDeferredValue } from 'react';

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  const defferedSize = useDeferredValue(size);

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return defferedSize;
};
